import { COLORS } from "../theme/theme";
import { FaWhatsapp } from "react-icons/fa";
import HeroCarousel from "../components/HeroCarousel";
import CompanySection from "../components/CompanySection";
import AIFeatures from "../components/AIFeatures";
import Reviews from "../components/Reviews";
import WhyChooseUs from "../components/WhyChooseUs";
import HomePortfolio from "../components/HomePortfolio";
import Aboutus from "../components/Aboutus";
import Industries from "../components/Industries";
import React, { useEffect } from "react";

import { Helmet } from "react-helmet-async";

const Home = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div style={{ background: COLORS.white }}>

      {/* ✅ SEO START */}
      <Helmet>
        <title>Custom Web Development & Software Solutions | Softcoders</title>

        <meta
          name="description"
          content="Softcoders provides custom web development, scalable software solutions, and mobile app development services designed for performance, security, and business growth."
        />

        <meta
          name="keywords"
          content="custom web development, software development company, mobile app development, scalable software solutions"
        />

        <meta name="robots" content="index, follow" />
        <link rel="canonical" href="https://softcoders.in/" />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta property="og:title" content="Softcoders - Web & Software Solutions" />
        <meta
          property="og:description"
          content="Build scalable digital products with Softcoders. Experts in web, software, and app development."
        />
        <meta property="og:url" content="https://softcoders.in/" />
        <meta property="og:image" content="https://softcoders.in/logo.png" />

        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Softcoders - Web & Software Solutions" />
        <meta
          name="twitter:description"
          content="Softcoders delivers high-performance web, software, and app development solutions."
        />
        <meta name="twitter:image" content="https://softcoders.in/logo.png" />

        {/* Structured Data */}
        <script type="application/ld+json">
          {`
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            "name": "Softcoders",
            "url": "https://softcoders.in/",
            "logo": "https://softcoders.in/logo.png"
          }
          `}
        </script>
      </Helmet>
      {/* ✅ SEO END */}

      {/* HERO */}
      <section style={{ paddingTop: "1px" }}>
        <HeroCarousel />
        <CompanySection />
      </section>

      <Aboutus />
      <Industries />
      <HomePortfolio />
      <Reviews />
      <AIFeatures />
      <WhyChooseUs />

      {/* WhatsApp Button */}
      <a
        href="https://wa.me/9254147455"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          position: "fixed",
          bottom: "25px",
          right: "25px",
          backgroundColor: "#25D366",
          color: "#fff",
          borderRadius: "50%",
          width: "60px",
          height: "60px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "28px",
          boxShadow: "0 4px 12px rgba(0,0,0,0.3)",
          zIndex: 1000,
          cursor: "pointer",
          transition: "transform 0.3s ease"
        }}
        onMouseEnter={(e) => (e.currentTarget.style.transform = "scale(1.1)")}
        onMouseLeave={(e) => (e.currentTarget.style.transform = "scale(1)")}
      >
        <FaWhatsapp />
      </a>

    </div>
  );
};

export default Home;